import template from './topdata-contact-login-detail.html.twig';

import './topdata-contact-login-detail.scss';

const { Criteria } = Shopware.Data;

Shopware.Component.register('topdata-contact-login-detail', {
    template,

    inject: ['repositoryFactory'],

    props: {
        contactId: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            contact: null,
            isLoading: false,
        };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('tdcl_customer_contact');
        },

        contactName() {
            if (!this.contact) {
                return '';
            }

            return `${this.contact.firstName} ${this.contact.lastName}`.trim();
        },

        detailsRoute() {
            return {
                name: 'topdata.contact.login.detail.details',
                params: { id: this.contactId },
            };
        },
    },

    watch: {
        contactId: {
            immediate: true,
            handler() {
                this.loadContact();
            },
        },
    },

    methods: {
        loadContact() {
            this.isLoading = true;

            const criteria = new Criteria();
            criteria.addAssociation('customer');
            criteria.addAssociation('salutation');

            this.repository.get(this.contactId, Shopware.Context.api, criteria)
                .then((contact) => {
                    this.contact = contact;
                })
                .catch(() => {
                    this.contact = null;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        onBack() {
            this.$router.push({ name: 'topdata.contact.login.list' });
        },
    },
});
